import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const DeleteInvoiceLineItemMutation = graphql.persisted(
  "DeleteInvoiceLineItem",
  graphql(`
    mutation DeleteInvoiceLineItem($input: DeleteInvoiceLineItemInput!) {
      deleteInvoiceLineItem(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

export { DeleteInvoiceLineItemMutation };

export function useDeleteInvoiceLineItem() {
  return useMutation(DeleteInvoiceLineItemMutation);
}
